import { BaseService } from "./BaseService";
import {
  CopyHotelRequestDto,
  CopyHotelResultDto,
  CopyTenantRequestDto,
  CopyTenantResultDto,
} from "@/types/system-copy";
import { tenantHeadersOptions } from "@/utils/hotelSubscriptionAccess";

class SystemCopyService extends BaseService {
  private readonly basePath = "/admin/system-copy";

  constructor() {
    super();
  }

  copyTenant(dto: CopyTenantRequestDto): Promise<CopyTenantResultDto> {
    return this.post<CopyTenantResultDto>(`${this.basePath}/tenant`, dto);
  }

  /**
   * `tenantId`: the tenant whose Hotel Brands the copy starts from (tenant
   * mode, platform admins), sent in `x-tenant-id`. The backend takes the
   * region from that tenant (DV-168).
   */
  copyHotel(
    dto: CopyHotelRequestDto,
    tenantId?: string,
  ): Promise<CopyHotelResultDto> {
    return this.post<CopyHotelResultDto>(
      `${this.basePath}/hotel`,
      dto,
      tenantHeadersOptions(tenantId),
    );
  }
}

export const systemCopyService = new SystemCopyService();
